// Geometry for the branch pull: the column rides the pull, and the branch
// draws in the void that opens above the fold. Pure module so the seam
// invariant — the indicator's band and the feed's translateY resolve from
// the same function — is unit-testable without the React/SCSS component.

export const FULL_PULL_HEIGHT = 100
// The bud finishes drawing only after its blurred edge has cleared the clipping
// boundary. This leaves 18.5px below the 64px center + 5.5px radius.
export const DRAW_EXTENT = 88
// Hold a little more open space while refreshing so the glow fades naturally
// into the canvas instead of ending on the feed boundary.
export const REFRESHING_HEIGHT = 96

// One resolver for the void height so the indicator's occupied band and the
// feed's translateY can never disagree — the seam stays glued. Zero once
// neither pulling nor refreshing: the mobile completion path leaves a stale
// pullProgress behind for a few frames, and resolving it would bounce the band
// upward before the retract.
export function resolveBranchPullHeight(
    isPulling: boolean,
    isRefreshing: boolean,
    pullProgress: number,
): number {
    if (!isPulling && !isRefreshing) return 0
    return isRefreshing ? REFRESHING_HEIGHT : Math.min(pullProgress, FULL_PULL_HEIGHT)
}

// Touch pulls: the void opens at a fixed fraction of finger travel until the
// branch is fully drawn, then resists (approaching FULL_PULL_HEIGHT) like a
// rubber band, so the band reads as part of the scroll rather than a trigger.
export const TOUCH_PULL_RATIO = 0.75
// A release past half the drawing still commits; shorter pulls slide home.
export const TOUCH_RELEASE_REFRESH_PULL = DRAW_EXTENT / 2
const TOUCH_PULL_RESISTANCE_PX = 24

export function resolveTouchPull(fingerDelta: number): number {
    if (fingerDelta <= 0) return 0
    const linear = fingerDelta * TOUCH_PULL_RATIO
    if (linear <= DRAW_EXTENT) return linear
    const slack = FULL_PULL_HEIGHT - DRAW_EXTENT
    return DRAW_EXTENT + slack * (1 - Math.exp(-(linear - DRAW_EXTENT) / TOUCH_PULL_RESISTANCE_PX))
}
